// TurfAI Service Exports

export * from './types';
export * from './config';
export { authService } from './authService';
export { dmsService } from './dmsService';
export { workflowService } from './workflowService';

import { turfaiConfig } from './config';
import { authService } from './authService';

// Helper function to initialize TurfAI services with authentication
export async function initializeTurfAI(identifier?: string, password?: string): Promise<boolean> {
  try {
    // Check if already authenticated
    if (authService.isAuthenticated()) {
      const isValid = await authService.verifyToken();
      if (isValid) {
        return true;
      }
    }

    // Login with provided credentials or test credentials
    const loginIdentifier = identifier || turfaiConfig.auth.testEmail;
    const loginPassword = password || turfaiConfig.auth.testPassword;
    
    console.log(`🔑 Initializing TurfAI with identifier: ${loginIdentifier}`);
    await authService.login(loginIdentifier, loginPassword);
    return true;
  } catch (error) {
    console.error('❌ Failed to initialize TurfAI services:', error);
    return false;
  }
}

// Helper to ensure authentication before operations
export async function ensureAuthenticated(): Promise<void> {
  if (!authService.isAuthenticated()) {
    throw new Error('Not authenticated. Please login first.');
  }
  
  // Verify token is still valid
  const isValid = await authService.verifyToken();
  if (!isValid) {
    // Try to re-authenticate with test credentials
    await authService.loginWithTestCredentials();
  }
}